import { c as _c } from "react/compiler-runtime";
interface HighlightedListProps {
  items: string[];
  className?: string;
}
export const HighlightedList = t0 => {
  const $ = _c(8);
  const {
    items,
    className: t1
  } = t0;
  const className = t1 === undefined ? "text-(--color-accent-3)" : t1;
  let t2;
  if ($[0] !== className || $[1] !== items) {
    let t3;
    if ($[3] !== className || $[4] !== items.length) {
      t3 = (item, index) => {
        const isLast = index === items.length - 1;
        return <strong key={item} className={className}>{item}{!isLast && ", "}</strong>;
      };
      $[3] = className;
      $[4] = items.length;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = items.map(t3);
    $[0] = className;
    $[1] = items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <>{t2}</>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};